 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AboutUs":"AboutUs","AlbumsInfo~Download~MyMusic~MyNote~PlayHistory~PlaylistsInfo~Search":"AlbumsInfo~Download~MyMusic~MyNote~PlayHistory~PlaylistsInfo~Search","AlbumsInfo~PlaylistsInfo":"AlbumsInfo~PlaylistsInfo","AlbumsInfo":"AlbumsInfo","PlaylistsInfo":"PlaylistsInfo","Download~MyMusic~MyNote~PlayHistory~Search":"Download~MyMusic~MyNote~PlayHistory~Search","Contact~PersonalDetails~Search~SignUp":"Contact~PersonalDetails~Search~SignUp","Search":"Search","Download":"Download","MyMusic":"MyMusic","MyNote":"MyNote","PlayHistory":"PlayHistory","ChangePassword":"ChangePassword","Contact~PersonalDetails~SignUp":"Contact~PersonalDetails~SignUp","Contact~SignIn~SignUp":"Contact~SignIn~SignUp","Contact":"Contact","SignUp":"SignUp","PersonalDetails":"PersonalDetails","SignIn":"SignIn","CustomerService":"CustomerService","Explore~Home":"Explore~Home","Explore~LabelsInfo":"Explore~LabelsInfo","Explore":"Explore","Home~LayoutWithHeader":"Home~LayoutWithHeader","Home":"Home","GenresCategory~LabelsInfo~MoodsCategory":"GenresCategory~LabelsInfo~MoodsCategory","LabelsInfo":"LabelsInfo","GenresCategory~MoodsCategory":"GenresCategory~MoodsCategory","GenresCategory":"GenresCategory","MoodsCategory":"MoodsCategory","LayoutWithHeader":"LayoutWithHeader","LicensingCookies":"LicensingCookies","LicensingPrivacy":"LicensingPrivacy","LicensingTerms":"LicensingTerms","MyPrefer":"MyPrefer","PasswordRecovery":"PasswordRecovery","PersonalHeader":"PersonalHeader","PreviewTool":"PreviewTool","ResetPassword":"ResetPassword","Test123":"Test123","ThemesCategory":"ThemesCategory","Validate":"Validate","licensing":"licensing"}[chunkId]||chunkId) + "." + {"AboutUs":"c20817a5","AlbumsInfo~Download~MyMusic~MyNote~PlayHistory~PlaylistsInfo~Search":"8e3cc3df","AlbumsInfo~PlaylistsInfo":"afdb24b2","AlbumsInfo":"35d0df22","PlaylistsInfo":"f7223754","Download~MyMusic~MyNote~PlayHistory~Search":"99e127a4","Contact~PersonalDetails~Search~SignUp":"f4910cdf","Search":"8bdbbb1c","Download":"6eb78b03","MyMusic":"9a920b4c","MyNote":"7c2b7748","PlayHistory":"cd637e55","ChangePassword":"f5fc7313","Contact~PersonalDetails~SignUp":"6ce990f0","Contact~SignIn~SignUp":"ad484b68","Contact":"e87ccf75","SignUp":"c6dec1aa","PersonalDetails":"d5de9695","SignIn":"e8b7d4e9","CustomerService":"f72396de","Explore~Home":"9ca4a021","Explore~LabelsInfo":"2d7c7966","Explore":"c13dbf70","Home~LayoutWithHeader":"c17c9e24","Home":"8acfa992","GenresCategory~LabelsInfo~MoodsCategory":"56ce4616","LabelsInfo":"f1b0843f","GenresCategory~MoodsCategory":"e8406ac7","GenresCategory":"67bdedd4","MoodsCategory":"dadd5a8d","LayoutWithHeader":"36e7afd4","LicensingCookies":"d58d2d4d","LicensingPrivacy":"c8e98ab2","LicensingTerms":"7697f4b1","MyPrefer":"409e148c","PasswordRecovery":"c24a525a","PersonalHeader":"9cfc1094","PreviewTool":"cbdfd1e1","ResetPassword":"157a2cd4","Test123":"95ef013b","ThemesCategory":"be4b25f4","Validate":"b6ea7214","licensing":"ce0b905f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AboutUs":1,"AlbumsInfo~Download~MyMusic~MyNote~PlayHistory~PlaylistsInfo~Search":1,"AlbumsInfo~PlaylistsInfo":1,"AlbumsInfo":1,"PlaylistsInfo":1,"Download~MyMusic~MyNote~PlayHistory~Search":1,"Search":1,"Download":1,"MyMusic":1,"MyNote":1,"PlayHistory":1,"ChangePassword":1,"Contact~SignIn~SignUp":1,"Contact":1,"SignUp":1,"PersonalDetails":1,"SignIn":1,"CustomerService":1,"Explore~Home":1,"Explore~LabelsInfo":1,"Explore":1,"Home~LayoutWithHeader":1,"Home":1,"GenresCategory~LabelsInfo~MoodsCategory":1,"LabelsInfo":1,"GenresCategory~MoodsCategory":1,"GenresCategory":1,"MoodsCategory":1,"LayoutWithHeader":1,"LicensingCookies":1,"LicensingPrivacy":1,"LicensingTerms":1,"MyPrefer":1,"PasswordRecovery":1,"PersonalHeader":1,"PreviewTool":1,"ResetPassword":1,"Test123":1,"ThemesCategory":1,"Validate":1,"licensing":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AboutUs":"AboutUs","AlbumsInfo~Download~MyMusic~MyNote~PlayHistory~PlaylistsInfo~Search":"AlbumsInfo~Download~MyMusic~MyNote~PlayHistory~PlaylistsInfo~Search","AlbumsInfo~PlaylistsInfo":"AlbumsInfo~PlaylistsInfo","AlbumsInfo":"AlbumsInfo","PlaylistsInfo":"PlaylistsInfo","Download~MyMusic~MyNote~PlayHistory~Search":"Download~MyMusic~MyNote~PlayHistory~Search","Contact~PersonalDetails~Search~SignUp":"Contact~PersonalDetails~Search~SignUp","Search":"Search","Download":"Download","MyMusic":"MyMusic","MyNote":"MyNote","PlayHistory":"PlayHistory","ChangePassword":"ChangePassword","Contact~PersonalDetails~SignUp":"Contact~PersonalDetails~SignUp","Contact~SignIn~SignUp":"Contact~SignIn~SignUp","Contact":"Contact","SignUp":"SignUp","PersonalDetails":"PersonalDetails","SignIn":"SignIn","CustomerService":"CustomerService","Explore~Home":"Explore~Home","Explore~LabelsInfo":"Explore~LabelsInfo","Explore":"Explore","Home~LayoutWithHeader":"Home~LayoutWithHeader","Home":"Home","GenresCategory~LabelsInfo~MoodsCategory":"GenresCategory~LabelsInfo~MoodsCategory","LabelsInfo":"LabelsInfo","GenresCategory~MoodsCategory":"GenresCategory~MoodsCategory","GenresCategory":"GenresCategory","MoodsCategory":"MoodsCategory","LayoutWithHeader":"LayoutWithHeader","LicensingCookies":"LicensingCookies","LicensingPrivacy":"LicensingPrivacy","LicensingTerms":"LicensingTerms","MyPrefer":"MyPrefer","PasswordRecovery":"PasswordRecovery","PersonalHeader":"PersonalHeader","PreviewTool":"PreviewTool","ResetPassword":"ResetPassword","Test123":"Test123","ThemesCategory":"ThemesCategory","Validate":"Validate","licensing":"licensing"}[chunkId]||chunkId) + "." + {"AboutUs":"cd6f8969","AlbumsInfo~Download~MyMusic~MyNote~PlayHistory~PlaylistsInfo~Search":"52e71657","AlbumsInfo~PlaylistsInfo":"579be4c4","AlbumsInfo":"6dfe927f","PlaylistsInfo":"e905a177","Download~MyMusic~MyNote~PlayHistory~Search":"88674f9f","Contact~PersonalDetails~Search~SignUp":"31d6cfe0","Search":"349aec28","Download":"1c6b7417","MyMusic":"d0f519a4","MyNote":"c151ac62","PlayHistory":"27172b2a","ChangePassword":"85ff9ec3","Contact~PersonalDetails~SignUp":"31d6cfe0","Contact~SignIn~SignUp":"80302606","Contact":"744f9f60","SignUp":"855b181c","PersonalDetails":"95edb036","SignIn":"530a7e35","CustomerService":"e97f8d84","Explore~Home":"c805756b","Explore~LabelsInfo":"876893ac","Explore":"4e963294","Home~LayoutWithHeader":"12c438ff","Home":"6f56be7a","GenresCategory~LabelsInfo~MoodsCategory":"a2cc245a","LabelsInfo":"e438c231","GenresCategory~MoodsCategory":"69897970","GenresCategory":"c10e0084","MoodsCategory":"a3b2f9ff","LayoutWithHeader":"aff37b07","LicensingCookies":"305be1db","LicensingPrivacy":"305be1db","LicensingTerms":"305be1db","MyPrefer":"7db68952","PasswordRecovery":"3cec2ad1","PersonalHeader":"8c75c032","PreviewTool":"a689123e","ResetPassword":"03b37c86","Test123":"8eee5e3a","ThemesCategory":"294a7f8b","Validate":"9ba0e2ad","licensing":"6793b309"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
